import { useFormContext } from 'react-hook-form';

import type { FormMultiSelectProps } from '../types';
import type { FieldValues } from 'react-hook-form';

import { MultiSelect } from '@/components/MultiSelect';

import { FormFieldShell } from '../FormFieldShell';

export const FormMultiSelect = <TFieldValues extends FieldValues = FieldValues>(
  props: FormMultiSelectProps<TFieldValues>,
) => {
  const {
    name,
    label,
    hint,
    placeholder,
    description,
    isRequired,
    options,
    multiSelectProps,
    onChange,
  } = props;
  const { clearErrors } = useFormContext<TFieldValues>();

  return (
    <FormFieldShell
      name={name}
      description={description}
      render={({ field, fieldState, fieldId }) => (
        <MultiSelect
          {...multiSelectProps}
          id={fieldId}
          value={(field.value as string[]) || []}
          onValueChange={(selectedValues) => {
            field.onChange(selectedValues);
            clearErrors(name);
            onChange?.(selectedValues);
          }}
          options={options}
          label={label}
          aria-label={label}
          isRequired={isRequired}
          hint={hint}
          placeholder={placeholder ?? label}
          aria-invalid={fieldState.invalid}
        />
      )}
    />
  );
};
